import Explorer from 'assets/account-center/block-explorer.svg?react'
import Copy from 'assets/account-center/copy.svg?react'
import Disconnect from 'assets/account-center/disconnect.svg?react'
import { AnalyticsArea, useAnalyticsEventTracker } from 'hooks'
import type React from 'react'
import { useStore } from 'services/store'
import { copyToClipboard, getBlockExplorerAddress } from 'utils'
import { useDisconnect } from 'wagmi'
import { StyledAccountDetailsRightContainer } from '../styled'
import TooltipText from './tooltip-buttons'
type TooltipProps = {
  account: string
  network: number
}

/**
 * React component for showing the account tooltips
 */
const AccountToolTip: React.FC<TooltipProps> = ({ account, network }) => {
  const { navigationEvent, clickEvent } = useAnalyticsEventTracker(AnalyticsArea.WalletManagement)
  const { disconnect } = useDisconnect()

  const { setConnectionModal } = useStore()

  const exploreAddress = () => {
    const address = getBlockExplorerAddress(account, network)
    navigationEvent(address, true)
  }

  const disconnectWallet = () => {
    clickEvent('disconnect Wallet')
    disconnect()
    setConnectionModal(false)
  }

  return (
    <StyledAccountDetailsRightContainer>
      <TooltipText
        contextualFeedback={'Copied'}
        clickedTextOffset={'-8px'}
        text="Copy"
        icon={Copy}
        action={() => copyToClipboard(account)}
      />
      <TooltipText text="Explore" icon={Explorer} action={exploreAddress} textOffset={'-7px'} />
      <TooltipText text="Disconnect" icon={Disconnect} action={disconnectWallet} />
    </StyledAccountDetailsRightContainer>
  )
}
export default AccountToolTip
